<template>
  <div>
    <el-table
      :data="vx_complainList"
      v-loading="vx_isTableLoading"
      style="margin: 0 auto; width: 80%"
    >
      <el-table-column label="隊編-姓名" prop="serviceName" />
      <el-table-column label="事件發生時間" prop="happenTime" />
      <el-table-column label="客服登記時間" prop="registerTime" />
      <el-table-column label="事件及描述">
        <template slot-scope="scope">
          <div>
            <div style="font-weight: bold">{{ scope.row.eventTitle }}</div>
            <div>{{ scope.row.desc }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="處理進度" prop="status" />
      <el-table-column label="動作">
        <template slot-scope="scope">
          <el-button type="primary" @click="onView(scope.$index)">
            檢視
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      @current-change="onPageChange"
      :page-count="vx_paging.totalPages"
      :current-page="vx_paging.currentPage"
      style="text-align: center; margin-top: 1rem"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  methods: {
    ...mapActions('managerStore', {
      vx_fetchComplainList: 'fetchComplainList',
    }),
    ...mapMutations('managerStore', {
      vx_setCurrentPage: 'SET_CURRENT_PAGE',
      vx_setIsUpdateComplainDialog: 'SET_IS_UPDATE_COMPLAIN_DIALOG',
      vx_setUpdateComplainDialog: 'SET_UPDATE_COMPLAIN_DIALOG',
      vx_setUpdateComplainId: 'SET_UPDATE_COMPLAIN_ID',
    }),
    onView(idx) {
      this.vx_setIsUpdateComplainDialog(true)
      const raw = this.vx_rawComplainList[idx]
      const driverInfo = this.vx_driverList.find(
        ({ id }) => id === raw.driver_id,
      )
      const dialog = {
        /* 司機 */
        driverId: raw.driver_id,
        driverLabel: driverInfo
          ? `${driverInfo.call_number}-${driverInfo.name}`
          : null,
        /* 客服種類 */
        typeId: raw.type_id,
        /* 事件發生時間 */
        happenTime: raw.event_time ? new Date(raw.event_time) : '',
        /* 客服建立時間 */
        createdAt: raw.createdAt ? new Date(raw.createdAt) : '',
        /* 結案時間 */
        finishTime: raw.finishTime ? new Date(raw.finishTime) : '',
        /* 最後處理時間（raw.lastTime為一個object包含_seconds, _nanoseconds兩個key） */
        lastTime: new Date(
          raw.lastTime._seconds * 1000 + raw.lastTime._nanoseconds / 1e6,
        ),
        /* 處理進度 */
        status: raw.status,
        /* 立案人員 */
        createPersonName: raw.add_service,
        /* 結案人員 */
        sealPersonId: raw.finishCustomerServiceId,
        /* 事件內容 */
        eventContent: raw.event_content,
        /* 處理描述 */
        processingDesc: raw.processing_description,
      }
      this.vx_setUpdateComplainDialog(dialog)
      this.vx_setUpdateComplainId(raw.id)
    },
    onPageChange(page) {
      this.vx_setCurrentPage(page)
      this.vx_fetchComplainList()
    },
  },
  computed: {
    ...mapGetters('managerStore', {
      vx_complainList: 'getComplainList',
    }),
    ...mapState('managerStore', {
      vx_paging: 'paging',
      vx_isTableLoading: 'isTableLoading',
      vx_rawComplainList: 'complainList',
      vx_driverList: 'driverList',
    }),
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/manager/components/ComplainTable.vue